import React from 'react';
import classnames from 'classnames';
import PopperPositionedPopover from '@wix/da-ds/pkg/popper/PopperPositionedPopover';
import PopoverWrapper from '@wix/da-ds/pkg/popper/PopoverWrapper';
import SimpleTooltipContent from '@wix/da-ds/pkg/tooltips/SimpleTooltipContent';
import { useReverseTheme } from '@wix/da-react-context/pkg/ThemeContext';
import popoverStyles from './PopoverWithTooltip.scss';
const TooltipPopover = ({ tooltip, arrowClassName, contentClassName, referenceClassName, children, tooltipOffset = [
    0,
    8
], onReferenceClick, renderReference })=>{
    const reverseTheme = useReverseTheme();
    return /*#__PURE__*/ React.createElement(PopperPositionedPopover, {
        renderPopover: ({ effectivePlacement, effectiveSecondaryPlacement, rootRef, arrowRef, contentStyle, arrowStyle, contentAttributes, arrowAttributes, updatePositioning })=>/*#__PURE__*/ React.createElement(PopoverWrapper, {
                effectivePlacement: effectivePlacement,
                effectiveSecondaryPlacement: effectiveSecondaryPlacement,
                rootRef: rootRef,
                arrowRef: arrowRef,
                contentStyle: contentStyle,
                arrowStyle: arrowStyle,
                updatePositioning: updatePositioning,
                contentAttributes: contentAttributes,
                arrowAttributes: arrowAttributes,
                forceTheme: reverseTheme,
                contentClassName: classnames(contentClassName, popoverStyles['new-tooltip'])
            }, /*#__PURE__*/ React.createElement(SimpleTooltipContent, null, tooltip)),
        className: referenceClassName,
        onReferenceClick: onReferenceClick,
        offsetModifier: tooltipOffset,
        renderReference: renderReference
    }, children);
};
TooltipPopover.displayName = 'TooltipPopover';
export default TooltipPopover;

//# sourceMappingURL=TooltipPopover.js.map